import React from "react";
import { Link } from "react-router";
import { Field, reduxForm } from "redux-form";
import Button from "material-ui/RaisedButton";
import ReduxTextField from "./ReduxTextField";
import { isValidEmail } from "../utils/form-utils";

const style = {
  passwordInput: {
    marginTop: 20,
  },
  buttonContainer: {
    textAlign: "right",
  },
  button: {
    marginTop: 40,
    marginBottom: 10,
  },
};

const LoginForm = (props) => {
  const { handleSubmit, pristine, submitting, loading, valid } = props;
  const currentLocation =
    (props.location && props.location.state && props.location.state.from) ||
    props.location;

  const loginLocation = {
    pathname: "/login",
    state: { from: currentLocation },
  };
  return (
    <form onSubmit={handleSubmit}>
      <h2>Chowreach</h2>
      <h4>Sign up</h4>
      <div>Create a new Chowreach account</div>
      <div style={{ marginBottom: 40 }} />
      <Field
        component={ReduxTextField}
        fullWidth
        name="email"
        label="Email"
        type="email"
      />
      <Field
        style={style.passwordInput}
        label="Password"
        fullWidth
        name="password"
        type="password"
        component={ReduxTextField}
      />
      <Field
        style={style.passwordInput}
        label="Confirm Password"
        fullWidth
        name="passwordConfirm"
        type="password"
        component={ReduxTextField}
      />
      {/* <Link to="/request-password">Forgot password?</Link> */}
      <div style={style.buttonContainer}>
        <Button
          type="submit"
          label={loading ? "Loading" : "Sign Up"}
          primary
          fullWidth
          disabled={pristine || submitting || loading || !valid}
          style={style.button}
        />
        <div style={{ textAlign: "left" }}>
          Already have an account? <Link to={loginLocation}>Log in</Link>
        </div>
      </div>
    </form>
  );
};

function validate(data) {
  const errors = {};

  if (!data.email) {
    errors.email = "Email is required";
  } else if (!isValidEmail(data.email)) {
    errors.email = "Enter a valid email";
  }

  if (!data.password) {
    errors.password = "Password is required";
  }

  if (!data.passwordConfirm) {
    errors.passwordConfirm = "Password Confirmation is required";
  } else if (data.password !== data.passwordConfirm) {
    errors.passwordConfirm = "Passwords do not match.";
  }

  return errors;
}

export default reduxForm({
  form: "LoginForm",
  validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/SignupForm.js